var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMediaSvgrepoCom1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_647)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.82577 17.179V6.8243L18.4551 12.0016L9.82577 17.179V17.179ZM23.9804 4.0203C16.4791 2.22696 8.50043 2.22696 1.00443 4.0203L0.492432 4.14297V19.8616L1.00443 19.9843C4.75509 20.8803 8.62043 21.335 12.4924 21.335C16.3658 21.335 20.2324 20.8803 23.9804 19.9843L24.4924 19.8616V4.14297L23.9804 4.02031V4.0203Z",
    fill: "#5D2EDE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_647"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.492432)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaSvgrepoCom1);
export default __webpack_public_path__ + "static/media/media-svgrepo-com 1.97db8c6159a33d821b17eddea51caeee.svg";
export { ForwardRef as ReactComponent };